import axios from 'axios';
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { loadingChange, login, modalChange } from '../../../redux/slices/AuthSlice';
import { useNavigate } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { URL } from '../../../config';

const PasswordForm = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [cookies, setCookie] = useCookies(['user']);
    const {email}=useSelector((state)=>state.AuthReducer);
    const [password,setPassword]=useState('');
    const [c_password,setC_password]=useState('');
    const [error_password,setError_password]=useState('');
    const [error_c_password,setError_c_password]=useState('');
    const passwordHandel=(e)=>{
        setPassword(e.target.value);
        setError_password("");
    }
    const c_passwordHandel=(e)=>{
        setC_password(e.target.value);
        setError_c_password("");
    }
    const signup=(e)=>{
        e.preventDefault();
        if (password.length<6) {
            setError_password("كلمة مرور ضعيفة");
            return;
        }
        if (password!=c_password) {
            setError_c_password(" تأكد من صحة كلمة المرور");
            return;
        }

        dispatch(loadingChange());
        console.log(email);
        axios.post(`${URL}/api/auth/register`, {
            email: email,
            password:password,
            c_password:c_password
       })
       .then(function (response) {
         if(response.data.success){          
            const user=response.data.data.user;
            const token=response.data.data.token;
            setCookie('user', user, { path: '/' });
            setCookie('token', token, { path: '/' });
            dispatch(login({user:user,token:token}));
            dispatch(modalChange());
             }
             else{
               console.log(response.data);
             }
             dispatch(loadingChange());
           })
       .catch(function (error) {
         dispatch(loadingChange());
     })}

  return (
    <form  onSubmit={signup} style={{ justifyContent:'center',alignItems:'center' }}>  
                <label for="password">الرقم السرى</label>
                <input style={{ borderColor:error_password&&'red',color:error_password&&'red' }} type='password' id="password" value={password} onChange={passwordHandel} />
                <p style={{ position:'absolute',color:'red',fontSize:'12px' }}>{error_password}</p>
                <label for="password" style={{ marginTop:'20px' }}> تأكيد الرقم السرى </label>
                <input style={{ borderColor:error_c_password&&'red',color:error_c_password&&'red' }} type='password' id="c_password" value={c_password} onChange={c_passwordHandel} />
                <p style={{ position:'absolute',color:'red',fontSize:'12px' }}>{error_c_password}</p>
                <input type='submit' style={{ marginTop:"30px" }}   value="انشاء الحســـاب"/>
            </form>
  )
}

export default PasswordForm
